import { setCurrentProject } from '@utils/axios'
import { action, makeAutoObservable } from 'mobx'
import { type TariffApi } from 'src/entities/tariff'

import { fetchAppState } from '@/entities/app-store'
import { log } from '../../../../config'
import { ackPauseNoticeRequest } from '../api'
import * as lib from '../lib'
import { type AppState, type Project } from '../types'

//
// По сути главный объек содержащий в себе пользователя
// и список его проектов
//

type State = string

const initialState = {
  user: null,
  projects: [],
}

export class AppStore {
  private isHydrated = false
  appState: AppState = initialState
  state: State = 'idle'
  project: Project | null
  tariffs: TariffApi.Tariff[] = []

  constructor() {
    makeAutoObservable(this, undefined, { autoBind: true })
  }

  @action
  async hydrate(appState: AppState) {
    if (this.isHydrated) {
      return
    }
    this.updateState(appState)
  }

  @action
  updateState(appState: AppState) {
    this.isHydrated = true
    this.appState = appState

    lib.updateCookies(appState)

    if (lib.getProjectId()) {
      this.project = this.getProjectById(lib.getProjectId())
    }

    if (!this.project && this.getFirstProjectId()) {
      this.project = this.getFirstProjectId()
    }

    if (this.project) {
      setCurrentProject(this.project.id)
    }
  }

  setProjectId(projectId: string) {
    this.project = this.getProjectById(projectId)
    lib.setProjectId(projectId)
    return this.project?.id === projectId
  }

  getProjectById(projectId: string): Project | null {
    return this.appState.projects.find((project) => project.id === projectId) ?? null
  }

  getFirstProjectId(): Project | null {
    return this.appState.projects[0] ?? null
  }

  setTariffs(tariffs: TariffApi.Tariff[]) {
    this.tariffs = tariffs
  }

  setTariffsTest(tariffs: TariffApi.Tariff[]) {
    this.tariffs = tariffs
  }

  @action
  async refresh() {
    fetchAppState().then((appState) => {
      //console.log('REFRESH STATTE', appState)
      if (appState) {
        this.updateState(appState)
      }
    })
  }

  // Подтвердить показ инфо-модалки о возобновлении синхронизации по текущему проекту.
  // Флаг гасим оптимистично (userinfo не рефетчится при SPA-навигации/смене проекта), запрос — fire-and-forget (идемпотентен).
  @action
  ackPauseNotice() {
    const project = this.project
    if (!project?.showPauseNotice) {
      return
    }
    project.showPauseNotice = false
    ackPauseNoticeRequest().catch((error) => log('ackPauseNotice error', error))
  }

  get isLoggedIn(): boolean {
    return this.appState.user !== null
  }
}
